export const config = {
  title: 'Add to Groups',
  description: 'Select a group to add the selected candidate(s) to',
  okText: 'Add to Group',
  width: 480,
  disabledUntilFilled: true,
  fields: [
    {
      name: 'groupId',
      label: 'Group',
      type: 'select',
      required: true,
      placeholder: 'Select a group',
      fetchOptionsKey: 'candidateGroups',
    },
  ],
};
